import React, { useEffect, useState } from 'react'
import { useServiceContext } from '../../root'

interface SiteInfoProps {
  contextId: string
  level: string
}

interface SiteData {
  address?: string
  studyName?: string
  siteName?: string
  siteNumber?: string
  folderEmailAddress?: string
}

const SiteInfo: React.FC<SiteInfoProps> = ({ contextId, level }) => {
  const context = useServiceContext()
  const { service, api } = context
  const { translate } = service.filter
  const LEVEL = service.staging.LEVEL
  const [site, setSite] = useState<SiteData>({})

  useEffect(() => {
    getStagingInfo(contextId)
  }, [contextId])

  const getStagingInfo = (id: string) => {
    if (typeof id === 'string' || typeof id === 'number') {
      api.etmf.getLinkedEntities().then((data: any) => {
        api.etmf
          .getSiteProperties(id, [
            data?.entityLinkMap?.SITE,
            data?.entityLinkMap?.TRIAL,
            data?.entityLinkMap?.SITE_ADDRESS,
            data?.entityLinkMap?.SITE_NUMBER
          ])
          .then((propsData: any) => {
            setSite((siteData) => ({
              ...siteData,
              address: propsData[data?.entityLinkMap?.SITE_ADDRESS],
              studyName: propsData[data?.entityLinkMap?.TRIAL],
              siteName: propsData[data?.entityLinkMap?.SITE],
              siteNumber: propsData[data?.entityLinkMap?.SITE_NUMBER]
            }))
          })
      })

      api.etmf.getSiteFolderEmailAddress(id).then((data: any) => {
        const email = data?.plain ? data?.plain()?.email : data?.email
        setSite((siteData) => ({
          ...siteData,
          folderEmailAddress: email
        }))
      })
    }
  }

  const copyAddress = () => {
    if (!site?.folderEmailAddress) return
    const el = document.createElement('textarea')
    el.value = site.folderEmailAddress
    el.setAttribute('readonly', '')
    el.style.position = 'absolute'
    el.style.left = '-9999px'
    document.body.appendChild(el)
    el.select()
    document.execCommand('copy')
    document.body.removeChild(el)
    service.toast.success('STAGING_AREA_EML_ADDR_COPIED')
  }

  return (
    <div className="mb20">
      <div>
        <strong>{translate('SITE_INFO_LABEL_STUDY')}</strong>
        <span>{' ' + (site?.studyName || '')}</span>
      </div>
      {level === LEVEL.site && (
        <div>
          <strong>{translate('SITE_INFO_LABEL_SITE_NAME')}</strong>
          <span>{' ' + (site?.siteName || '')}</span>
        </div>
      )}
      {level === LEVEL.site && (
        <div>
          <strong>{translate('SITE_INFO_LABEL_STUDY_ENV_SITE_NO')}</strong>
          <span>{' ' + (site?.siteNumber || '')}</span>
        </div>
      )}
      {level === LEVEL.site && (
        <div>
          <strong>{translate('SITE_INFO_LABEL_ADDRESS')}</strong>
          <span>{' ' + (site?.address || '')}</span>
        </div>
      )}
      {!!site?.folderEmailAddress && (
        <div>
          <strong>{translate('SITE_INFO_LABEL_EMAIL_ADDRESS_TO_FOLDER')}</strong>
          <span>{' ' + site.folderEmailAddress}</span>
          <button
            type="button"
            className="btn btn-chita btn-second btn-copy-link new-copy-button"
            onClick={copyAddress}
          >
            {translate('BTN_COPY_LINK')}
          </button>
        </div>
      )}
    </div>
  )
}

export default SiteInfo
